<template>
	<div>
		<v-list-group @click="handleClick" v-if="hasChildren" v-model="active">
			<template v-slot:activator>
				<v-list-tile :to="categoryUrl" v-if="hasChildren">
					<v-list-tile-content>
						<v-list-tile-title>
							<span v-for="n in level" :key="n">&ndash;</span>
							{{ category.name }}
						</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>
			</template>

			<template v-if="sortedChildren">
				<category-item
					v-for="child in sortedChildren"
					:key="child.slug"
					:parent="category"
					:level="level + 1"
					:parentRoute="categoryUrl"
					:category="child"
				></category-item>
			</template>
			<v-list-tile disabled v-else>
				<v-list-tile-content>
					<v-list-tile-title>
						<v-progress-circular
							size="18"
							width="2"
							indeterminate
							color="primary"
						></v-progress-circular
						>&nbsp;Loading...
					</v-list-tile-title>
				</v-list-tile-content>
			</v-list-tile>
		</v-list-group>

		<v-list-tile v-else ripple :to="categoryUrl">
			<v-list-tile-content>
				<v-list-tile-title>
					<span v-for="n in level" :key="n">&ndash;</span>
					{{ category.name }}
				</v-list-tile-title>
			</v-list-tile-content>
		</v-list-tile>
	</div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import CategoryItem from "./CategoryItem";
const { sortCategories } = require("@root/helpers");
import { log } from "util";
import { setTimeout } from "timers";

export default {
	name: "category-item",

	data() {
		return {
			active: false,
			currentChildren: false
		};
	},

	props: {
		category: {
			default: {}
		},

		parent: {
			default: null
		},

		level: {
			default: 0
		},

		parentRoute: {
			default: ""
		}
	},

	components: {
		CategoryItem
	},

	computed: {
		categoryUrl() {
			if (this.parentRoute) {
				return `${this.parentRoute}/${this.category.route_slug}`;
			}

			return this.category.route_slug;
		},

		hasChildren() {
			if (this.children) {
				return this.children.length > 0;
			}

			return this.category.children_count > 0;
		},

		children() {
			return this.currentChildren;
		},

		sortedChildren() {
			return sortCategories(this.children);
		},

		isOpen() {
			return this.$route.fullPath.indexOf(this.categoryUrl) >= 0;
		}
	},

	methods: {
		...mapActions("document_center", ["getCategories"]),
		...mapMutations("document_center", ["setLoadedCategory"]),

		handleClick(e) {
			this.toggleActive();
		},

		toggleActive(active) {
			if (!_.isBoolean(active)) {
				active = !this.active;
			}

			if (active === this.active) {
				return;
			}

			this.$set(this, "active", active);

			if (active && this.hasChildren && !this.children) {
				this.getCategories({ category: this.category.slug }).then(
					({ data }) => {
						this.$set(this, "currentChildren", data);
					}
				);
			}
		}
	},

	created() {
		this.setLoadedCategory(this.category);
		this.toggleActive(this.isOpen);
	}
};
</script>
